import './About.css';
import { StandardLayout } from '../../layouts/StandardLayout';

export default function About(){
    const content = 
        <div className='aboutText'>
            <p>Inspired by Craigslist. Thanks, Craig!</p>
            <p>Created by <a href='https://graceis.online/' target='_blank' rel='noreferrer'>Grace Manning</a>.</p>
        </div>
    return(
        <StandardLayout title={"about classifieds.lol"} content={content} />
    );
};